import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  loadingProgram: {
    id: 'programs.loading',
    defaultMessage: 'Loading program',
    description: 'Screen reader text shown while the program page is loading',
  },
  programLoadError: {
    id: 'programs.loadError',
    defaultMessage: 'Unable to load this program. Please try again later.',
    description: 'Error message shown when the program page fails to load',
  },
  coursesLeft: {
    id: 'programs.coursesLeft',
    defaultMessage: '{count, plural, one {# course left} other {# courses left}}',
    description: 'Banner label showing how many courses remain in the program',
  },
  progressTitle: {
    id: 'programs.progressTitle',
    defaultMessage: 'Course Progress',
    description: 'Heading for the program progress card',
  },
  continueLearning: {
    id: 'programs.continueLearning',
    defaultMessage: 'Continue Learning',
    description: 'Button label that takes the learner to the next course to study',
  },
  completedCount: {
    id: 'programs.completedCount',
    defaultMessage: 'Completed {completed} of {total} courses',
    description: 'Label showing how many program courses the learner has finished',
  },
  aboutTitle: {
    id: 'programs.aboutTitle',
    defaultMessage: 'About the program',
    description: 'Heading for the program description section',
  },
  aboutSeeMore: {
    id: 'programs.aboutSeeMore',
    defaultMessage: 'See more',
    description: 'Button label to expand the truncated program description',
  },
  aboutSeeLess: {
    id: 'programs.aboutSeeLess',
    defaultMessage: 'See less',
    description: 'Button label to collapse the expanded program description',
  },
  coursesTitle: {
    id: 'programs.coursesTitle',
    defaultMessage: 'Courses in this program',
    description: 'Section heading for the list of courses in the program',
  },
  statusCompleted: {
    id: 'programs.statusCompleted',
    defaultMessage: 'Completed',
    description: 'Status badge shown on a finished course in the program',
  },
  statusInProgress: {
    id: 'programs.statusInProgress',
    defaultMessage: 'In progress',
    description: 'Status badge shown on a course the learner has started but not finished',
  },
  moreSkills: {
    id: 'programs.moreSkills',
    defaultMessage: '+{count} Skills',
    description: 'Badge indicating additional skill tags beyond those shown',
  },
  reviews: {
    id: 'programs.reviews',
    defaultMessage: '{rating} ({count} reviews)',
    description: 'Compact rating label showing average score and number of reviews',
  },
  backToLearning: {
    id: 'programs.backToLearning',
    defaultMessage: 'Back to Learning',
    description: 'Alt text for the back button on the program page banner',
  },
});

export default messages;
